"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvFileNameForNodeEnv = getEnvFileNameForNodeEnv;
const DEFAULT_ENV = 'local';
const envFileFromNodeEnv = {
    production: '.env.production',
    test: '.env.test',
    ci: '.env.ci',
    local: '.env',
    dev: '.env.development',
};
/**
 * Get the path to the .env file for the current environment.
 * @param env The current environment.
 * @param configDir The config directory.
 * @returns The path to the .env file.
 */
function getEnvFileNameForNodeEnv(nodeEnv) {
    return envFileFromNodeEnv[(nodeEnv || DEFAULT_ENV)];
}
//# sourceMappingURL=processEnv.js.map